module.exports = __webpack_public_path__ + "img/success-okr.8ca54046.svg";